import { useEffect, Suspense } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Nav } from './components/layout/Nav'
import { Footer } from './components/layout/Footer'
import { ClientOnlyChatWidget } from './components/chat/ClientOnlyChatWidget'
import { CookieConsent } from './components/CookieConsent'

export default function App() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      // Allow the target section to render, then scroll to it
      const id = hash.replace(/^#/, '')
      const scrollToEl = () => {
        const el = id ? document.getElementById(id) : null
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        } else {
          window.scrollTo(0, 0)
        }
      }
      const t = requestAnimationFrame(() => {
        requestAnimationFrame(scrollToEl)
      })
      return () => cancelAnimationFrame(t)
    } else {
      window.scrollTo(0, 0)
    }
  }, [pathname, hash])

  return (
    <div className="app-root" suppressHydrationWarning>
      <Nav />
      <main>
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <ClientOnlyChatWidget />
      <CookieConsent />
    </div>
  )
}
